import React from "react";
import "../../css/pagination.scss";

const Pagination = ({
  currentPage,
  pageSize,
  totalPages,
  totalItems,
  onPageChange,
  onPageSizeChange,
}) => {
  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleJumpToPage = (e) => {
    if (e.key === "Enter") {
      const page = parseInt(e.target.value);
      if (page >= 1 && page <= totalPages) {
        onPageChange(page);
        e.target.value = "";
      }
    }
  };

  // 生成页码按钮
  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      // 如果总页数小于等于最大可见页数，显示所有页码
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            className={`pagination-btn ${currentPage === i ? "active" : ""}`}
            onClick={() => onPageChange(i)}
          >
            {i}
          </button>
        );
      }
    } else {
      // 否则显示当前页附近的页码
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      } else if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }

      // 第一页
      if (startPage > 1) {
        pages.push(
          <button
            key={1}
            className="pagination-btn"
            onClick={() => onPageChange(1)}
          >
            1
          </button>
        );
        if (startPage > 2) {
          pages.push(
            <span key="ellipsis-start" className="pagination-ellipsis">
              ...
            </span>
          );
        }
      }

      // 中间页码
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <button
            key={i}
            className={`pagination-btn ${currentPage === i ? "active" : ""}`}
            onClick={() => onPageChange(i)}
          >
            {i}
          </button>
        );
      }

      // 最后一页
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pages.push(
            <span key="ellipsis-end" className="pagination-ellipsis">
              ...
            </span>
          );
        }
        pages.push(
          <button
            key={totalPages}
            className="pagination-btn"
            onClick={() => onPageChange(totalPages)}
          >
            {totalPages}
          </button>
        );
      }
    }

    return pages;
  };

  return (
    <div className="pagination">
      <span className="pagination-total">共 {totalItems} 条</span>

      <button
        className="pagination-btn"
        disabled={currentPage === 1}
        onClick={handlePrevPage}
      >
        &lt;
      </button>

      {renderPageNumbers()}

      <button
        className="pagination-btn"
        disabled={currentPage >= totalPages}
        onClick={handleNextPage}
      >
        &gt;
      </button>

      <select
        className="pagination-select"
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
      >
        <option value="10">10条/页</option>
        <option value="20">20条/页</option>
        <option value="50">50条/页</option>
      </select>

      <div className="pagination-jump-container">
        <span className="pagination-jump">前往</span>
        <input
          type="number"
          className="pagination-jump-input"
          min="1"
          max={totalPages}
          placeholder={currentPage}
          onKeyPress={handleJumpToPage}
        />
        <span className="pagination-jump">页</span>
      </div>
    </div>
  );
};

export default Pagination;
